import React, { useEffect, useState } from "react";
import { convertTimeToAMPM, generalGetFunction, generalPostFunction } from "../Globals/globalFunctions";
import { useNavigate } from "react-router-dom";
import { SvgIcon } from "../Components/SvgIcons";

function PlayerHistory() {
	const navigate = useNavigate();
	const [player, setPlayer] = useState("");
	const [allAccountOfOwner, setAllAccountOfOwner] = useState([]);
	const [gameName, setGameName] = useState("");

	const [rawData, setRawData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [refresh, setRefresh] = useState(0);
	const [loading, setLoading] = useState(false);

	const [dateFilter, setDateFilter] = useState({
		start_date: "",
		end_date: "",
	});
	const [dateType, setDateType] = useState("");

	const getHistoryByPlayer = async () => {
		setLoading(true);
		const payload = {
			username: player,
		};

		const gamePorts = {
			spin2win: "3001",
			joker12card: "3003",
			joker16card: "3002",
		};

		const port = gamePorts[gameName];

		try {
			const response = await generalPostFunction("/getticketsplacedbygameid", payload, port);
			if (response.status == 200) {
				setRawData(response.data);
			}
		} catch (err) {
			console.log();
		} finally {
			setLoading(false);
		}
	};

	const getAccountsByOwner = async () => {
		const payload = {
			username: "admin",
		};

		try {
			const response = await generalPostFunction(`/getuserdatabyowner`, payload, "3000");
			if (response.status == 200) {
				setAllAccountOfOwner(response.data);
			}
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		if (dateFilter.start_date && dateFilter.end_date) {
			const startDate = new Date(dateFilter.start_date);
			const endDate = new Date(dateFilter.end_date);

			const filteredData = rawData.filter((item) => {
				const betDate = new Date(item.betdate);
				return betDate >= startDate && betDate <= endDate;
			});

			setFilteredData(filteredData);
		} else {
			setFilteredData(rawData);
		}
	}, [dateFilter, rawData]);

	useEffect(() => {
		const today = new Date();
		let filtered = [];

		switch (dateType) {
			case "today": {
				filtered = rawData.filter((item) => {
					const betDate = new Date(item.betdate);
					return betDate.toDateString() === today.toDateString();
				});
				break;
			}

			case "7_days": {
				const sevenDaysAgo = new Date();
				sevenDaysAgo.setDate(today.getDate() - 7);

				filtered = rawData.filter((item) => {
					const betDate = new Date(item.betdate);
					return betDate >= sevenDaysAgo && betDate <= today;
				});
				break;
			}

			case "1_month": {
				const oneMonthAgo = new Date();
				oneMonthAgo.setMonth(today.getMonth() - 1);

				filtered = rawData.filter((item) => {
					const betDate = new Date(item.betdate);
					return betDate >= oneMonthAgo && betDate <= today;
				});
				break;
			}

			case "3_month": {
				const threeMonthsAgo = new Date();
				threeMonthsAgo.setMonth(today.getMonth() - 3);

				filtered = rawData.filter((item) => {
					const betDate = new Date(item.betdate);
					return betDate >= threeMonthsAgo && betDate <= today;
				});
				break;
			}

			default:
				filtered = rawData;
		}

		setFilteredData(filtered);
	}, [dateType, rawData]);

	useEffect(() => {
		getHistoryByPlayer();
		getAccountsByOwner();
	}, [refresh, gameName]);

	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>
										Player History{" "}
										<button className="clearButton" onClick={() => setRefresh(refresh + 1)}>
											<SvgIcon name="refresh" />
										</button>
									</h4>
								</div>
								<div className="buttonGroup">
									<button effect="ripple" className="panelButton gray" onClick={() => navigate(-1)}>
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
									<button type="button" className="panelButton" onClick={getHistoryByPlayer}>
										<span className="text">Search</span>
										<span className="icon">
											<SvgIcon name="search" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
							{/* <div className="tableHeader">
                <div className="showEntries">
                  <label>Show</label>
                  <select className="formItem">
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                  </select>
                  <label>entries</label>
                </div>
                <div className="searchBox position-relative">
                  <label>Search:</label>
                  <input type="search" name="Search" className="formItem" />
                </div>
              </div> */}
							<div className="tableHeader">
								<div className="d-flex justify-content-xl-end">
									{/* <div className="formRow border-0">
                    <label className="formLabel text-start mb-0 w-100">
                      Super Stokez
                    </label>
                    <select className="formItem">
                      <option value={"admin"}>Admin</option>
                    </select>
                  </div>
                  <div className="formRow border-0">
                    <label className="formLabel text-start mb-0 w-100">
                      Stokez
                    </label>
                    <select className="formItem">
                      <option>Admin</option>
                      <option>Admin2</option>
                    </select>
                  </div> */}
									<div className="formRow border-0">
										<label className="formLabel text-start mb-0 w-100">Player</label>
										<select className="formItem" onChange={(e) => setPlayer(e.target.value)}>
											{allAccountOfOwner && allAccountOfOwner.length > 0 ? (
												allAccountOfOwner.map((item, index) => {
													return (
														<option key={index} value={item.username}>
															{item.username}
														</option>
													);
												})
											) : (
												<option>No Player Found</option>
											)}
										</select>
									</div>
									<div className="formRow border-0">
										<label className="formLabel text-start mb-0 w-100">Game Name</label>
										<select className="formItem" onChange={(e) => setGameName(e.target.value)}>
											<option value={"spin2win"}>Spin 2 Win</option>
											<option value={"joker12card"}>12 Card</option>
											<option value={"joker16card"}>16 Card</option>
										</select>
									</div>
									<div className="formRow border-0 ps-xl-0">
										<label className="formLabel text-start mb-0 w-100">Date Filter</label>
										<select className="formItem" value={dateType} onChange={(e) => setDateType(e.target.value)}>
											<option value="today">Today</option>
											<option value="7_days">Last 7 Days</option>
											<option value="1_month">Last 1 Month</option>
											<option value="3_month">Last 3 Months</option>
										</select>
									</div>
									<div className="formRow border-0">
										<label className="formLabel text-start mb-0 w-100">From Date</label>
										<div className="d-flex w-100">
											<input
												type="date"
												className="formItem"
												value={dateFilter.start_date}
												onChange={(e) =>
													setDateFilter((prev) => ({
														...prev,
														start_date: e.target.value,
													}))
												}
											/>
										</div>
									</div>
									<div className="formRow border-0">
										<label className="formLabel text-start mb-0 w-100">To Date</label>
										<div className="d-flex w-100">
											<input
												type="date"
												className="formItem"
												value={dateFilter.end_date}
												onChange={(e) =>
													setDateFilter((prev) => ({
														...prev,
														end_date: e.target.value,
													}))
												}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="tableContainer">
								<table>
									<thead>
										<tr>
											<th>#</th>
											<th>Username</th>
											<th>Game Name</th>
											<th>Total Bet</th>
											<th>Total Won</th>
											<th>Status</th>
											<th>Date</th>
											<th>Time</th>
										</tr>
									</thead>
									<tbody>
										{filteredData && filteredData.length > 0 ? (
											filteredData.map((item, index) => {
												return (
													<tr key={index}>
														<td>{index + 1}</td>
														<td>{item.username}</td>
														<td>{gameName == "spin2win" ? "Spin 2 Win" : gameName == "joker12card" ? "Joker 12 Card" : gameName == "joker16card" ? "16 Card" : ""}</td>
														<td>
															<div class="dropdown custom">
																<span type="button" data-bs-toggle="dropdown" aria-expanded="false">
																	{item.total}
																</span>
																<ul class="dropdown-menu" style={{ columnCount: 2 }}>
																	{gameName == "spin2win" ? (
																		<>
																			<li>
																				<b>0:</b> <span>{item["N0"]}</span>
																			</li>
																			<li>
																				<b>1:</b> <span>{item["N1"]}</span>
																			</li>
																			<li>
																				<b>2:</b> <span>{item["N2"]}</span>
																			</li>
																			<li>
																				<b>3:</b> <span>{item["N3"]}</span>
																			</li>
																			<li>
																				<b>4:</b> <span>{item["N4"]}</span>
																			</li>
																			<li>
																				<b>5:</b> <span>{item["N5"]}</span>
																			</li>
																			<li>
																				<b>6:</b> <span>{item["N6"]}</span>
																			</li>
																			<li>
																				<b>7:</b> <span>{item["N7"]}</span>
																			</li>
																			<li>
																				<b>8:</b> <span>{item["N8"]}</span>
																			</li>
																			<li>
																				<b>9:</b> <span>{item["N9"]}</span>
																			</li>
																		</>
																	) : gameName == "joker12card" ? (
																		<>
																			<li>
																				<b>KC:</b> <span>{item["N0"]}</span>
																			</li>
																			<li>
																				<b>KD:</b> <span>{item["N1"]}</span>
																			</li>
																			<li>
																				<b>KS:</b> <span>{item["N2"]}</span>
																			</li>
																			<li>
																				<b>KH:</b> <span>{item["N3"]}</span>
																			</li>
																			<li>
																				<b>QC:</b> <span>{item["N4"]}</span>
																			</li>
																			<li>
																				<b>QD:</b> <span>{item["N5"]}</span>
																			</li>
																			<li>
																				<b>QS:</b> <span>{item["N6"]}</span>
																			</li>
																			<li>
																				<b>QH:</b> <span>{item["N7"]}</span>
																			</li>
																			<li>
																				<b>JC:</b> <span>{item["N8"]}</span>
																			</li>
																			<li>
																				<b>JD:</b> <span>{item["N9"]}</span>
																			</li>
																			<li>
																				<b>JS:</b> <span>{item["N10"]}</span>
																			</li>
																			<li>
																				<b>JH:</b> <span>{item["N11"]}</span>
																			</li>
																		</>
																	) : (
																		""
																	)}
																</ul>
															</div>
														</td>
														<td>{item.winrs ? item.winrs : "0"}</td>
														<td>{item.status ? item.status : "N/A"}</td>
														<td>{item.betdate.split("T")[0]}</td>
														<td>{convertTimeToAMPM(item.bettime.split("T")[1].split(".")[0])}</td>
													</tr>
												);
											})
										) : (
											<tr>
												<td colSpan={99}>No Data Found</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default PlayerHistory;
